<template>
    <div class="authentication absolute inset-0 flex items-center justify-center">
        <div class="authentication-box bg-white rounded-lg flex flex-col items-center justify-center">
            <img class="authentication-logo" src="@/assets/images/auth-logo.svg">
            
            <img class="authentication-illus rounded-full" src="@/assets/images/auth-illus.jpg">

            <div
            v-if="showLogin"
            class="authentication-form flex flex-col items-center justify-evenly border border-blue rounded-md"
            @keyup.enter="submit">
                <h1 class="uppercase text-xs font-main-bold">Connexion</h1>
                
                <div class="w-full text-right">
                    <div class="authentication-inputs border border-blue border-opacity-50 rounded">
                        <input class="border-b border-blue border-opacity-50" type="text" name="email" placeholder="Email" v-model="form.email">
                        <input type="password" name="password" placeholder="Mot de passe" v-model="form.password">
                    </div>
                    <router-link :to="{ name: 'ForgotPassword' }">Mot de passe oublié ?</router-link>
                </div>


                <div v-if="error" class="text-red text-sm">
                    {{ error }}
                </div>

                <button
                type="submit" 
                class="authentication-submit faa-button-blue"
                :class="{
                    'loading': hasPendingRequest
                }"
                :disabled="hasPendingRequest"
                @click.prevent="submit">
                    Se connecter
                    <div class="faa-loader">
                        <span></span>
                        <span></span>
                        <span></span>
                        <span></span>
                    </div>
                </button>
            </div>

            <div
            v-else
            class="authentication-form flex flex-col items-center justify-center border border-blue rounded-md"
            @keyup.enter="submit">
                <!-- <h1 class="uppercase text-xs font-main-bold mb-10">Bienvenue</h1> todo: intro/text ?-->

                <button class="authentication-submit faa-button-blue mb-6" type="submit" @click.prevent="showLogin = true">Connexion</button>

                <button class="authentication-submit faa-button-blue" type="submit" @click.prevent="$router.push({ name: 'subscription' })">Inscription</button>
            </div>
        </div>
    </div>
</template>

<script>
    import { mapActions } from 'vuex'

    export default {
        name: 'Authentication',
        data(){
            return {
                hasPendingRequest: false,
                showLogin: false,
                form: {
                    email: '',
                    password: '',
                },
                error: null,
            }
        },
        methods: {
            ...mapActions('Auth', ['login']),
            async submit() {
                if (this.hasPendingRequest)
                    return

                this.hasPendingRequest = true
                this.error = null

                if (this.form.email != '' && this.form.password != '') {
                    try {
                        await this.login(this.form)
                    } catch(err) {
                        this.error = "Email ou mot de passe incorrect !"
                        this.hasPendingRequest = false
                        return 
                    }
                    
                    // Check if we need & can to show the first login scenario
                    await this.$store.dispatch('Locations/getBySlug', 'map_first_login')

                    const mapLocation = this.$store.state.Locations.itemsBySlug['map_first_login']

                    if (mapLocation && mapLocation.scenarios && mapLocation.scenarios.length > 0) {
                        const id = mapLocation.scenarios[0].scenario_id

                        const logs = await this.$store.dispatch('Logs/getByKeyAndType', {
                            data_key: id,
                            type_slug: 'scenario_start',
                        })

                        if (!logs || logs.length <= 0) {
                            this.$router.push({
                                name: 'Scenario',
                                params: {
                                    id,
                                    hideHomeButton: true,
                                }
                            })
                            this.hasPendingRequest = false
                            return
                        }
                    }
                    
                    this.$router.push({ name: 'Home' })
                    return
                }

                this.hasPendingRequest = false
            },
        },
    }
</script>

<style lang="scss" scoped>

.authentication {
    .authentication-box {
        width: 40%;
        height: 90%;
        max-width: 672px;
        max-height: 960px;

        .authentication-logo {
            height: 7.2%;
            margin-bottom: 8%;
        }

        .authentication-illus {
            height: 28%;
            margin-bottom: 8.7%;
        }

        .authentication-form {
            padding: 0 7.4%;
            width: 80%;
            height: 40%;

            button, input {
                @apply block appearance-none;

                &:focus {
                    @apply outline-none;
                }
            }

            a {
                @apply block text-sm mt-1 text-blue;
            }

            .authentication-inputs {
                width: 100%;

                input {
                    @apply w-full bg-transparent m-auto px-4 py-3 text-sm;
                    &::placeholder {
                        @apply text-blue;
                    }
                } 
            }

            .authentication-submit {
                button:focus {
                    @apply shadow-outline;
                }
            }
        }
    }
}

</style>
